/**
 * @generated SignedSource<<ad0c9c190bdf69e5fde71b8277f905a9>>
 * @relayHash 6dc10adfa969b09c1b06975f34ac228c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d0b3a7bef3eddd4d4a096a54ea0f33956cea6628ef99a09797a5fcce800b0331

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectGroupPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectGroupPermissionsSettingsAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupPermissionsSettings">;
};
export type ProjectGroupPermissionsSettingsAggQuery = {
  response: ProjectGroupPermissionsSettingsAggQuery$data;
  variables: ProjectGroupPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "ProjectGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "TownsquareProjectAppCapabilities",
            "kind": "LinkedField",
            "name": "projects_capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveAppLevelPermissions_extension"
                  }
                ]
              }
            ]
          },
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "TownsquareProjectsAppPermissionPolicyConnection",
            "kind": "LinkedField",
            "name": "projects_appPermissionPolicies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectsAppPermissionPolicyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectsAppPermissionPolicy",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "scopedGroupId"
                      },
                      {
                        "concreteType": "IdentityGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDefaultGroup"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userCount"
                      },
                      {
                        "concreteType": "TownsquareProductRole",
                        "kind": "LinkedField",
                        "name": "productRoles",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "role"
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectsAppPermissionEntry",
                        "kind": "LinkedField",
                        "name": "appPermissions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "permission"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPermitted"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6dc10adfa969b09c1b06975f34ac228c",
    "id": "d0b3a7bef3eddd4d4a096a54ea0f33956cea6628ef99a09797a5fcce800b0331",
    "metadata": {},
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": "query ProjectGroupPermissionsSettingsAggQuery(\n  $containerId: ID!\n  $isM3GroupPermsEnabled: Boolean!\n) {\n  ...ProjectGroupPermissionsSettings_1GKbF9 @include(if: $isM3GroupPermsEnabled)\n}\n\nfragment ProjectGroupPermissionsSettings_1GKbF9 on Query {\n  projects_appPermissionPolicies(containerId: $containerId, first: 100) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        id\n        scopedGroupId\n        group {\n          name\n          id\n        }\n        isDefaultGroup\n        isEditable\n        userCount\n        productRoles {\n          role\n        }\n        appPermissions {\n          permission\n          isPermitted\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ad342251ac7fde7f812879d1344b3ea";

export default node;
